import { Controller } from "@hotwired/stimulus"

// Toggles VAT display on/off for price displays
// Usage: 
//   - data-controller="vat-toggle" data-vat-toggle-subtotal-value="100" data-vat-toggle-rate-value="0.22"
//   - data-vat-toggle-target="checkbox" on the toggle checkbox
//   - data-vat-toggle-target="vatRow" on VAT line item rows
//   - data-vat-toggle-target="vatAmount" on the VAT amount display
//   - data-vat-toggle-target="priceDisplay" on total price displays
export default class extends Controller {
  static targets = ["checkbox", "vatRow", "vatAmount", "priceDisplay"]
  static values = { subtotal: Number, rate: Number }

  connect() {
    this.toggle()
  }

  toggle() {
    const showVat = this.checkboxTarget.checked
    
    if (showVat) {
      const vatAmount = (this.subtotalValue * this.rateValue).toFixed(2)
      const totalWithVat = (this.subtotalValue * (1 + this.rateValue)).toFixed(2)
      
      if (this.hasVatAmountTarget) {
        this.vatAmountTarget.textContent = '€' + vatAmount
      }
      
      this.vatRowTargets.forEach(row => row.style.display = 'flex')
      this.priceDisplayTargets.forEach(display => {
        if (display.textContent.includes('/')) {
          display.textContent = '€' + totalWithVat + display.textContent.substring(display.textContent.indexOf('/'))
        } else {
          display.textContent = '€' + totalWithVat
        }
      })
    } else {
      this.vatRowTargets.forEach(row => row.style.display = 'none')
      this.priceDisplayTargets.forEach(display => {
        if (display.textContent.includes('/')) {
          display.textContent = '€' + this.subtotalValue.toFixed(2) + display.textContent.substring(display.textContent.indexOf('/'))
        } else {
          display.textContent = '€' + this.subtotalValue.toFixed(2)
        }
      })
    }
  }
}
